import { api } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { register } from '~/core/repository'
import { model as tvCategoryModel } from '~/entities/tv/category'
import { model as root } from '~/entities/tv/channels'
import { genPagesLogic } from '~/shared/effector'
import { nay, T } from '~/shared/helpers'

export const initTvCategoryPage = createEvent<{
  categoryId: string
  query: URLSearchParams
}>()
export const left = createEvent()

sample({
  clock: initTvCategoryPage,
  filter: not(api.tv.initChannelsCategoryAbortableFx.pending),
  fn: ({ categoryId }) => ({
    categoryId: Number(categoryId),
  }),
  target: api.tv.initChannelsCategoryAbortableFx,
})

export const loadMoreChannelsByCategory = genPagesLogic(
  api.tv.$channelsByCategoryPageInfo,
  api.tv.loadChannelsFx
)

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

// *
// * STORES
// *

/********** Skeleton logics starts ***********/

sample({
  clock: initTvCategoryPage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.tv.loadChannelsFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

// clear paginatable stores
api.tv.$channelsByCategory.reset(initTvCategoryPage)

register(tvCategoryModel.$channelsByCategory, '$channelsByCategory')
register(loadMoreChannelsByCategory, 'loadMoreChannelsByCategory')
register(root.$infiniteTvTitle, '$tv/category/infiniteTvTitle')
